import { SxProps } from '@mui/material';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Link } from '@tanstack/react-router';

export const NotFoundSection = ({ sx }: { sx?: SxProps }) => {
  return (
    <Container sx={sx}>
      <Typography variant="h3" sx={{ mb: 2 }}>
        Sorry, page not found!
      </Typography>

      <Typography sx={{ color: 'text.secondary' }}>
        Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your
        spelling.
      </Typography>

      <Button component={Link} to="/" size="large" variant="soft" sx={{ mt: 4 }}>
        Go to home
      </Button>
    </Container>
  );
};
